import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import SNETHeader from "shared/dist/components/SNETHeader";
import LoggedInActions from "./LogActions/LoggedInActions.js";
import LoggedOutActions from "./LogActions/LoggedOutActions.js";
import { GlobalRoutes } from "../../GlobalRouter/Routes";
import { navbarItems } from "./navbarItemsConstant.js";
import { selectOrganization } from "../../Services/Redux/actionCreators/organizationActions";

const Header = () => {
    const { selectedOrganizationUuid, isLoggedIn, orgFoundInBlockchain } = useSelector((state) => ({
        selectedOrganizationUuid: state.organization.selectedOrganizationUuid,
        orgFoundInBlockchain: state.organization.foundInBlockchain,
        isLoggedIn: state.user.isLoggedIn,
    }));
    const dispatch = useDispatch();
    const history = useHistory();

    const handleLogoClick = async () => {
        if (!isLoggedIn) {
            return;
        }
        if (!selectedOrganizationUuid) {
            history.push(GlobalRoutes.OVERVIEW.path);
            return;
        }
        await dispatch(selectOrganization(selectedOrganizationUuid));
        if (orgFoundInBlockchain) {
            return history.push(
                GlobalRoutes.SERVICES.path.replace(":orgUuid", selectedOrganizationUuid)
            );
        }
        return history.push(
            GlobalRoutes.ORG_SETUP_STATUS.path.replace(":orgUuid", selectedOrganizationUuid)
        );
    };

    const navbarItemsByLogin = !isLoggedIn ? navbarItems : null;

    return (
        <SNETHeader
            isLoggedIn={isLoggedIn}
            onLogoClick={handleLogoClick}
            portalName="AI Publisher"
            color="white"
            LoggedInActions={LoggedInActions}
            LoggedOutActions={LoggedOutActions}
            navbarItems={navbarItemsByLogin}
            isMobileHeaderVisible={false}
        />
    );
};

export default Header;
